import { AI_ENDPOINTS } from 'features/ai-generators/constants';
import { SECONDARY_API_CLIENT } from 'services/API';

export const generateCandidatePresentation = async data => {
  return SECONDARY_API_CLIENT.post(AI_ENDPOINTS.candidatesPresentationMaker, data);
};

export const generateJobOrderPresentation = async data => {
  return SECONDARY_API_CLIENT.post(AI_ENDPOINTS.jobOrdersPresentationMaker, data);
};

export const ratePresentationMakerGenerated = async ({ id, score }) => {
  return SECONDARY_API_CLIENT.post(AI_ENDPOINTS.ratePresentationMakerGenerated, { id, score });
};
